import { createRouter,createWebHistory,RouterView } from 'vue-router'
import routes from './routes'
import { usePermissionStoreWithOut } from '@/store/modules/permission';
import { isEmpty } from '@/libs/utils'

// 加载路由文件
const modules = import.meta.glob('@/views/**/*.vue');
export const loadRouteView = (value)=>{
  if(!isEmpty(value)) {
      const path = modules[value.replace("@","/src")];
      if(!path){
          console.error(`未找到${value}文件`)
          return RouterView;
      }

      return path;
  }
}

// 对路由进行过滤处理
export const filterAsyncRoutes = (routes)=>{
    return routes.map((route) => {
        route.component = loadRouteView(route.component);
        return route;
    });
}

// 取得第一个路由
export const findFirstValidRoute = (routes)=>{
    for(const route of routes){
        if(!isEmpty(route.path) && route.meta?.hidden == 1) {
            return route.path;
        }

        if (route.children) {
            const path = findFirstValidRoute(route.children)
            if (!isEmpty(path)) return path;
        }
    }

    return undefined;
}

/**
 * 重置路由
 */
export const resetRouter = ()=>{
    const { routes } = usePermissionStoreWithOut();
    routes.forEach((route) => {
        const name = route.name
        if (name && router.hasRoute(name)) {
            router.removeRoute(name)
        }
    })
}

const router = createRouter({
    history: createWebHistory('/home/'), // createWebHistory createWebHashHistory
    routes,
    scrollBehavior (to, from, savedPosition) {
		return { top: 0 }
	}
})

export default router;